import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFavorites } from '../../context/FavoritesContext';
import { getImageUrl } from '../../utils/imageUrl';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { toggleFavorite, isFavorite } = useFavorites();
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    // Guard: without a usable identifier the URL becomes "/product/"
    // which doesn't match the route and silently redirects to "/".
    const identifier = product.slug || product.id;
    if (!identifier) return;
    navigate(`/product/${identifier}`);
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation(); // Prevent card click when clicking heart
    toggleFavorite(product);
  };

  const isProductFavorite = isFavorite(product.id);

  return (
    <div className="product-card" onClick={handleClick}>
      {/* Favorite Heart Icon */}
      <button 
        className={`favorite-btn ${isProductFavorite ? 'active' : ''}`}
        onClick={handleFavoriteClick}
        title={isProductFavorite ? t('product.removeFromFavorites') : t('product.addToFavorites')}
      >
        {isProductFavorite ? <img style={{width: '16px'}} src={require('../../assets/heart.png')}/> : <img style={{width: '16px'}} src={require('../../assets/favourites.png')} />}
      </button>

      <div className="product-image-container">
        {product.primary_image && !imageError ? (
          <img
            className="product-image"
            src={getImageUrl(product.primary_image)} 
            alt={product.name}
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="product-image-placeholder">
            📦
          </div>
        )}
        {product.stock < 10 && product.stock > 0 && (
          <div className="product-badge">{t('product.onlyLeft', { count: product.stock })}</div>
        )}
      </div>
      <div className="product-info">
        <div className="product-category">{product.category_name || t('product.uncategorized')}</div>
        <h3 className="product-name">{product.name}</h3>
        <div className="product-price">₾{parseFloat(product.price).toFixed(2)}</div>
        <div className={`product-stock ${product.stock === 0 ? 'out-of-stock' : ''}`}>
          {product.stock > 0 ? `${product.stock} ${t('product.inStock')}` : t('product.outOfStock')}
        </div>
      </div>

      <style>{`
        .product-card {
          position: relative;
        }

        .favorite-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          background: rgba(255, 255, 255, 0.9);
          border: none;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 20px;
          z-index: 10;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .favorite-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .favorite-btn.active {
          background: rgba(255, 255, 255, 0.95);
        }
      `}</style>
    </div>
  );
};

export default ProductCard;
